module.exports = __webpack_public_path__ + "static/media/a14.2d36e9c6.jpg";